interface SoundwaveProps {
  playing?: boolean;
  bars?: number;
  className?: string;
}

export default function Soundwave({ playing = true, bars = 8, className = "" }: SoundwaveProps) {
  return (
    <div
      className={`flex items-center gap-[3px] h-6 ${className}`}
      style={{ minHeight: "24px", contain: "layout size" }}
    >
      {Array.from({ length: bars }).map((_, i) => (
        <span
          key={i}
          className="wave-bar"
          style={{
            height: `${8 + Math.sin(i * 1.2) * 8 + 6}px`,
            animationPlayState: playing ? "running" : "paused",
            opacity: playing ? 1 : 0.3,
          }}
        />
      ))}
    </div>
  );
}
